import React from 'react'
import { useSelector } from '../../../../hooks/useSelector'
import { Segment, Header } from 'semantic-ui-react'
import { isSpecialRiftTurn, truncateCash } from '@prometheus/utils'
import classNames from 'classnames'
import { Box, Card, CardBody, CardHeader, Stack, Table, Typography } from '@prometheus/components'

export const WaitingOnPlayers = () => {
  const players_choosing = (useSelector(s => s.game.metadata?.players_choosing_planet) || [])
  const players = useSelector(s => s.game.metadata?.players) || {}
  const turn = useSelector(s => s.game.metadata?.turn) || 0
  const is_map = useSelector(s => s.game.galaxy_display)

  if (!players_choosing.length) {
    return null
  }

  if (isSpecialRiftTurn(turn)) {
    return (
      <Box style={{ position: 'relative', zIndex: 1 }}>
        <Card borderColor='secondary' padding="sm">
          <Stack>
            <Typography variant='h4' retro color="secondary">Special Rift in effect!</Typography>
            <Table
              hoverable
              columns={[{
                key: 'name',
                label: 'Player'
              }, {
                key: 'equity',
                label: 'Equity',
              }, {
                key: 'status',
                label: 'Status'
              }]}
              data={Object.values(players).sort((a, b) => a.public_equity - b.public_equity).filter(p => !p.dead).map((player) => ({
                name: player.name,
                equity: <Typography variant="body2" color={player.public_equity >= 0 ? 'success' : 'danger'}>{truncateCash(player.public_equity, {}, true)}</Typography>,
                status: (() => {
                  if (players_choosing[0] === player.id) {
                    return <span style={{ color: 'yellow' }}>Choosing...</span>
                  }

                  if (players_choosing.indexOf(player.id) === -1) {
                    return <span style={{ color: 'white' }}>{player.current_planet}</span>
                  }

                  return <span>Waiting...</span>
                })()
              }))}
            />
          </Stack>
        </Card>
      </Box>
    )
  }

  let message = ''
  if (players_choosing.length && Object.keys(players).length) {
    message += `${players_choosing.map(p => players[p].name).join(', ')}`
  }

  return (
    <Box style={{ zIndex: 1, position: 'relative' }}>
      <Card padding="sm" style={{ zIndex: 1, position: 'relative' }} borderColor='warning'>
        <CardHeader><Typography retro color="warning" variant="h4">Waiting for Players</Typography></CardHeader>
        <CardBody><Typography variant="h4">{message}</Typography></CardBody>
      </Card>
    </Box>
  )
}
